import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const createSupplierCityMutation = graphql(`
  mutation CreateSupplierCity($name: String!, $state: State!) {
    createSupplierCity(name: $name, state: $state) {
      id
      name
      slug
      region
      state
      lat
      lng
    }
  }
`);

export type CreatedSupplierCity = ResultOf<
  typeof createSupplierCityMutation
>["createSupplierCity"];
